import React from "react";
import './Startpage.scss'
import {Button, Col, Row} from "antd";
import {useTranslation} from "../../context/translation-context";

function Startpage({user, onButtonClick}) {

    const translation = useTranslation()

    return <div className="startpage">
        <Row>
            <Col span={12}>
                <h1>{translation.startseite.ueberschrift}</h1>
            </Col>
        </Row>
        <Row>
            <Col span={12}>
                <p>{translation.startseite.paragraph1}</p>
            </Col>
        </Row>
        <Row>
            <Col span={12}>
                <p>{translation.startseite.paragraph2}</p>
            </Col>
        </Row>
        <Row>
            <Col span={12}>
                <p>
                    {translation.startseite.paragraph3.zeile1}
                    <br/>
                    {translation.startseite.paragraph3.zeile2}
                </p>
            </Col>
        </Row>
        <Row>
            <Col span={12}>
                <div className="startpage-kontakt-navigation">
                    <div>
                        <strong>{translation.startseite.paragraph4.labelTelefon}</strong> <a href={`tel:${translation.startseite.paragraph4.linkTelefon}`}>{translation.startseite.paragraph4.valueTelefon}</a>
                        <br/>
                        <strong>{translation.startseite.paragraph4.labelEmail}</strong> <a href={`mailto:${translation.startseite.paragraph4.linkEmail}`}>{translation.startseite.paragraph4.valueEmail}</a>
                    </div>
                    <div>
                        {user
                            ? <Button className={"ant-btn ant-btn-primary"} type="button" onClick={() => onButtonClick()}>{translation.startseite.paragraph4.buttonZurAnwendung}</Button>
                            : <div>
                                <p>{translation.startseite.paragraph4.labelButtonZurAnmeldung}</p>
                                <Button className={"ant-btn ant-btn-primary"} type="button" onClick={() => onButtonClick()}>{translation.startseite.paragraph4.buttonZurAnmeldung}</Button>
                            </div>
                        }
                    </div>
                </div>
            </Col>
        </Row>
    </div>
}

export default Startpage
